<template>
  <div class="row">
    <div class="col-12">
      <ques-item title="Payment Plans">
        <p class="mb-4" >The State of Illinois has provided access to payment plans. Individual and business taxpayers who are able to make a "good faith down payment" can pay the remaining balance monthly. 97tax calculates your down payment as at least 5% of your balance, and the remaining amount paid over a maximum of {{paymentPlanConfig.maxMonth}} months to make a reasonable offer to the State. During checkout, you can choose to increase these amounts and select a monthly payment date.</p>
        <p class="mb-4" >Illinois will not need a financial statement unless your remaining balance after your down payment is over $5,000. 97tax includes the appropriate financial statement in your tax packet. Take a look at our FAQ further down this page for more information.</p>
        <p>Hiring a local attorney is expensive and unnecessary, and trying it yourself can cause months of delay and even more frustration and cost. We prepare  all the Illinois Department of Revenue documents necessary to submit your payment plan. Within one business day, we'll mail your completed application to the mailing address you provide. Just sign the forms, drop it in the mail, and you're done.</p>
      </ques-item>

      <ques-item title="Flexibility">
        <p class="mb-5" >By applying for a payment plan online through 97tax.com, our system will automatically calculate the minimum payment allowed by Illinois with a maximum of {{paymentPlanConfig.maxMonth}} months. During the process, you can also select your normal monthly due date and increase payments to pay off your balance faster.</p>
        <p class="mb-5" ><a href="#top-hero"><span class="font-weight-bold" style="color: #0098c3; text-decoration: underline;">Click here</span></a> to see if you qualify and get your application for an installment plan started now.</p>
      </ques-item>

      <ques-item title="Eligibility">
        <p>The maximum amount you can owe to the Department of Revenue and still be eligible for an installment agreement is  ${{formatCurrencyWithCommas(paymentPlanConfig.maxAmount)}}. You also must:</p>
        <ul style="padding-inline-start: 20px;">
          <li>
            Pay the balance in a maximum of {{paymentPlanConfig.maxMonth}} months.
          </li>
          <li>
            Have filed all of your Illinois state tax returns.
          </li>
        </ul>
        <p>It's important to note that if you miss payments on the Illinois installment agreement, the state will cancel the payment plan.</p>
      </ques-item>
    </div>
  </div>
</template>
<script>
  import { paymentPlansConfig } from '../../config/plans-config';
  export default {
    data() {
      return {
        paymentPlanConfig:paymentPlansConfig.illinoisPaymentPlan
      }
    },
  }
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Raleway:400,700,800,900,900i');
  p {
    font-weight: 400;
    font-family: 'Raleway', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/IllinoisPaymentPlanQues.vue